import React, { Component } from "react";

import {
  BLImage,
  BLHeader,
  BLSectionHeader,
  media
} from "../AppStyles/GenericStyledComponents";
import BLStyleGuide from "../AppStyles/BLStyleGuide";

import SimpleTextBar from "../components/Generic/SimpleTextBar";
import ContactUsSection from "./Contact Us/ContactUsSection";

import Logo from "../../assets/images/BuiltByBL.png";

const ResponsiveImage = BLImage.extend`
  ${media.desktop`
    height: 60%;
  `}
`;

class Footer extends Component {
  render() {
    return (
      <div>
        <SimpleTextBar textBig="let's build something great together" />
        <ContactUsSection />
        <SimpleTextBar
          href="/"
          flexDirection={"column"}
          backgroundColor={BLStyleGuide.color.title}
          textColor={BLStyleGuide.color.title}
          height={"250px"}
          padding={"0"}
          tabletHeight={"200px"}
          mobileHeight={"150px"}
        >
          <BLImage
            src={Logo}
            boxShadow={"none"}
            height={"50%"}
            smallTabletHeight={"50%"}
            margin={"10px"}
            width={"unset"}
            alt="Betterment Labs Brand Mountains"
          />
          <BLHeader
            color={BLStyleGuide.color.highlight}
            fontWeight={"100"}
            fontSize={BLStyleGuide.font.size.medium}
            tabletFontSize={BLStyleGuide.font.size.mediumSmall}
            smallTabletSize={BLStyleGuide.font.size.small}
            mobileFontSize={BLStyleGuide.font.size.smallTiny}
            fontFamily={BLStyleGuide.font.family.monoFur}
          >
            Copyright © {`${1900 + new Date().getYear()}`} | Betterment Labs
          </BLHeader>
          <BLSectionHeader
            fontSize={BLStyleGuide.font.size.medium}
            tabletFontSize={BLStyleGuide.font.size.mediumSmall}
            smallTabletSize={BLStyleGuide.font.size.small}
            mobileFontSize={BLStyleGuide.font.size.smallTiny}
            fontFamily={BLStyleGuide.font.family.monoFur}
            color={BLStyleGuide.color.highlight}
            width={"fit-content"}
          >
            Park City, Utah
          </BLSectionHeader>
        </SimpleTextBar>
      </div>
    );
  }
}

// class MattsFooter extends Component {
//   render() {

//     return (
//       <BLDiv height={'500px'} backgroundColor={BLStyleGuide.color.tertiary} flexDirection={'row'}>
//         <BLFooterAnchor
//           padding={'0 2%'}
//           href={"/"}
//           textAlign={'left'}
//           fontWeight={'200'}
//           fontSize={BLStyleGuide.font.size.mediumSmall}
//           width={'15%'}
//           color={BLStyleGuide.color.bodyText}
//           hoverColor={'white'}
//           >
//           Betterment<br/>Labs
//         </BLFooterAnchor>
//         <BLDiv width={'70%'}>
//           <BLDiv flexDirection={'row'} width={'100%'}>
//             <FooterGridLink href={"/ourwork"} color={BLStyleGuide.color.bodyText} fontWeight={'300'} width={'33.3%'} textAlign={'center'} borderBottom={`1px solid ${BLStyleGuide.color.background}`} borderRight={`1px solid ${BLStyleGuide.color.background}`} >Our Work</FooterGridLink>
//             <FooterGridLink href={"/philosophy"} color={BLStyleGuide.color.bodyText} fontWeight={'300'} width={'33.3%'} textAlign={'center'} borderBottom={`1px solid ${BLStyleGuide.color.background}`} borderRight={`1px solid ${BLStyleGuide.color.background}`}>Philosophy</FooterGridLink>
//             <FooterGridLink href={"/team"} color={BLStyleGuide.color.bodyText} fontWeight={'300'} width={'33.3%'} textAlign={'center'} borderBottom={`1px solid ${BLStyleGuide.color.background}`}>The Team</FooterGridLink>
//           </BLDiv>
//           <BLDiv flexDirection={'row'} width={'100%'}>
//             <FooterGridLink href={"/bootcampinternships"} color={BLStyleGuide.color.bodyText} fontWeight={'300'} width={'50%'} textAlign={'center'} borderRight={`1px solid ${BLStyleGuide.color.background}`}>Bootcamp &amp; Internships</FooterGridLink>
//             <FooterGridLink href={"/contactus"} color={BLStyleGuide.color.bodyText} fontWeight={'300'} width={'50%'} textAlign={'center'}>Contact Us</FooterGridLink>
//           </BLDiv>
//         </BLDiv>
//         <BLFooterAnchor fontWeight={'200'} color={BLStyleGuide.color.bodyText} width={'15%'} textAlign={'center'} fontSize={BLStyleGuide.font.size.small}>Park City,<br/>Utah</BLFooterAnchor>
//       </BLDiv>
//     );
//   }
// }

export default Footer;



// WEBPACK FOOTER //
// ./src/interface/components/Footer.js